import styled from 'styled-components';

export const Summary = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	padding: 4px 0 8px;
`;

export const ViewToolbar = styled.div`
	display: flex;
	gap: 8px;
	padding: 4px 0 12px;
`;

export const ToolbarButton = styled.button<{ $danger?: boolean }>`
	font-size: 12px;
	font-weight: 500;
	padding: 4px 10px;
	border-radius: 4px;
	border: 1px solid ${({ theme, $danger }) => ($danger ? theme.red[500] : theme.gray[200])};
	background: transparent;
	color: ${({ theme, $danger }) => ($danger ? theme.red[700] : theme.gray[700])};

	&:hover:not(:disabled) {
		background: ${({ theme, $danger }) => ($danger ? theme.red[200] : theme.gray[100])};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const List = styled.div`
	max-height: 360px;
	overflow-y: auto;
	margin: 4px 0 8px;
`;

export const FileEntry = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.gray[100]};

	&:last-child {
		border-bottom: none;
	}
`;

export const FileRow = styled.div`
	display: flex;
	align-items: center;
	padding: 6px 12px;
	gap: 8px;
`;

export const FilePath = styled.span`
	font-size: 13px;
	font-family: 'SF Mono', 'Fira Code', 'Fira Mono', Menlo, Consolas, monospace;
	color: ${({ theme }) => theme.gray[800]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
	flex: 1;
`;

export const StatusBadge = styled.span<{ $status: 'added' | 'modified' | 'removed' }>`
	font-size: 11px;
	font-weight: 500;
	padding: 1px 6px;
	border-radius: 3px;
	flex-shrink: 0;
	color: ${({ theme, $status }) =>
		$status === 'added'
			? theme.green[800]
			: $status === 'modified'
			? theme.blue[800]
			: theme.red[700]};
	background: ${({ theme, $status }) =>
		$status === 'added'
			? theme.green[200]
			: $status === 'modified'
			? theme.blue[300]
			: theme.red[200]};
`;

export const RowActions = styled.div`
	display: flex;
	gap: 4px;
	flex-shrink: 0;
`;

export const RowButton = styled.button`
	font-size: 11px;
	padding: 2px 6px;
	border-radius: 3px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background: transparent;
	color: ${({ theme }) => theme.gray[600]};

	&:hover:not(:disabled) {
		background: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[800]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const InlineSummary = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	padding: 2px 12px 8px 24px;
	line-height: 1.4;
`;

export const EmptyState = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
	text-align: center;
	padding: 24px 12px;
`;
